<slot style="display: none" #legendOptions name="legend-layer-options"></slot>
<slot style="display: none" #legendGroupOptions name="legend-layer-group-options"></slot>
<div *ngIf="mapViewRef && nodes && nodes.length > 0" class="legend-container">
    <tree-root id="legendTree" #legendTree [nodes]="nodes" [options]="options" class="legend-list" (toggleExpanded)="toggleExpanded($event)" (updateData)="setExpanded()">
        <ng-template #treeNodeTemplate let-node let-index="index">
            <div class="legend-box">
                <div class="reorder icon-ui-drag-horizontal" title="Reorder"></div>
                <div class="content"
                     (dragstart)="$event.stopPropagation();" (drag)="$event.stopPropagation();"
                     (dragend)="$event.stopPropagation();" draggable="false"
                     (mousedown)="$event.stopPropagation();">
                    <div class="loading icon-ui-refresh" *ngIf="node.data.loading"></div>
                    <input (change)="check(node, node.data.checked)" type="checkbox" [title]="node.data.checked ? 'Hide' : 'Show'"
                           [indeterminate]="node.data.indeterminate" [(ngModel)]="node.data.checked">
                    <ng-container *ngIf="node.hasChildren || node.data.nodeType == 'group'">
                        <span class="group-title">{{ node.data.name }}</span>
                        <div class="extras">
                            <span (click)="groupOptionSelected($event.target, node.data.id)"
                                  [attr.uniqueGroupId]="node.data.id" #groupOptions class="group"></span>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="node.isLeaf">
                        <mc-legend-symbol-ng [uniqueLayerId]="node.data.id" (onsymbolchange)="onSymbolChange($event)"></mc-legend-symbol-ng>
                        <textarea *ngIf="!readonly" type="text" name="layer" class="layer-name" rows="1"
                                  (change)="layerNameChange($event, node.data.id)"
                                  (input)="recalcuateRows($event.target)"
                                  (resize)="recalcuateRows($event.target)"
                                  [(ngModel)]="node.data.name"></textarea>
                        <span *ngIf="readonly" class="layer-name">{{ node.data.name }}</span>
                        <div class="extras" (opendetails)="toggleLayerDetails(node)">
                            <span (click)="optionSelected($event.target, node.data.id)"
                                  [attr.uniqueLayerId]="node.data.id" #options class="item"></span>
                            <i *ngIf="node.data.hasDetails && showLayerDetail" class="icon-ui-down" style="margin-left: 3px;"
                               (click)="toggleLayerDetails(node)"></i>
                        </div>
                        <div *ngIf="node.data.showDetails" class="layer-container" style="position: relative;">
                            <i *ngIf="!showLayerDetail" class="icon-ui-up" style="position: absolute; top: 3px; right: 3px;"
                               (click)="toggleLayerDetails(node)"></i>
                            <mc-layer-detail-ng [uniqueLayerId]="node.data.id"></mc-layer-detail-ng>
                        </div>
                        <div class="break"></div>
                        <mc-legend-data-ng [node]="node"></mc-legend-data-ng>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </tree-root>
</div>
